/**
 * @file
 * Pluxee slider accessibility script.
 */

(function (Drupal, $) {
    'use strict';
    Drupal.behaviors.pluxeeSliderAccessibility = {
        attach: function (context, settings) {
            $(once('slider-focus', '.coh-slider-container', context)).each(function () {
                const $slider = $(this);
                let triggeredByClick = false;

                $slider.find('.slick-prev, .slick-next, .coh-style-slider-pagination li button').on('click', function () {
                    triggeredByClick = true;
                });

                $slider.find('.slick-slider').on('afterChange', function (event, slick, currentSlide) {
                    if (triggeredByClick) {
                        const $activeSlide = $(slick.$slides.get(currentSlide));

                        setTimeout(() => {
                            $activeSlide.focus();
                            triggeredByClick = false;
                        }, 0);
                    }
                });
            });

            $(once('aria-current-sync', '.slick-dots', context)).each(function () {
                syncAriaCurrentOnSelectionChange(this);
                updateAriaCurrent(this);
            });

            function updateAriaCurrent(container) {
                const all = container.querySelectorAll('[aria-current]');
                all.forEach(el => el.removeAttribute('aria-current'));

                const selected = container.querySelector('[aria-selected="true"]');
                if (selected) {
                    selected.setAttribute('aria-current', 'true');
                }
            }

            function syncAriaCurrentOnSelectionChange(container) {
                const observer = new MutationObserver(() => {
                    updateAriaCurrent(container);
                });

                observer.observe(container, {
                    attributes: true,
                    subtree: true,
                    attributeFilter: ['aria-selected'],
                });
            }

            $(once('slick-aria-labels', '.coh-slider-container', context)).each(function () {
                const $slider = $(this);

                function updateSliderNavigationLabels() {
                    const $dots = $slider.find('.slick-dots li button');
                    const total = $dots.length;

                    $dots.each(function (index) {
                        this.setAttribute('aria-label', Drupal.t('Slide @index of @total', {
                            '@index': index + 1,
                            '@total': total
                        }));
                    });

                    $slider.find('.slick-prev').attr('aria-label', Drupal.t('Previous slide'));
                    $slider.find('.slick-next').attr('aria-label', Drupal.t('Next slide'));
                }

                updateSliderNavigationLabels();

                $slider.find('.slick-slider').on('afterChange', function () {
                    setTimeout(() => {
                        updateSliderNavigationLabels();
                    }, 0);
                });
            });
        }
    };
})(Drupal, jQuery);
